// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2LIqo","header":"ClearentDisclaimer_header__31YMU","inner":"ClearentDisclaimer_inner__3oCjd"};